import React from 'react'
import { makeStyles } from '@material-ui/core/styles';
import Divider from '@material-ui/core/Divider';
import UserDisabledItem from './Disabled';

const useStyles = makeStyles((theme) => ({
    menuDivider: {
        width: '100%',
    },
}));


/**
 * Componente para mostrar un divisor en el menú de usuario.
 * @returns {React.Component}
 */
export default function UserDividerItem() {

    const classes = useStyles();

    return (
        <UserDisabledItem disableGutters>
            <Divider className={classes.menuDivider} variant="fullWidth" />
        </UserDisabledItem>
    )
}
